import { Link } from '@coop/components';
import { CoopLogoIcon } from '@coop/icons';

import styles from './Footer.module.scss';

const FooterContact = (props: Pick<FrontendFooter, 'bottomLinks'>) => {
    return (
        <>
            <div className={styles.FooterLogo}>
                <a href="/" aria-label="Till startsidan">
                    <CoopLogoIcon
                        height={26}
                        className={styles.FooterLogoImage}
                        aria-hidden
                        style={{ fill: 'currentColor' }}
                    />
                </a>
            </div>

            <p className={styles.FooterContact}>
                <span>
                    Coop Sverige{' '}
                    <Link
                        href="https://www.google.se/maps/place/Coop+Huvudkontor/59.3598297,17.9783251,15z/data=!4m5!3m4!1s0x0:0x824f828e19b3770c!8m2!3d59.3598297!4d17.9783251"
                        target="_blank"
                        rel="noopener noreferrer"
                        size="inline"
                    >
                        171 88 Solna
                    </Link>
                    , <span style={{ display: 'inline-block' }}>Telefon: 010-742 00 00</span>,&nbsp;
                    {/* dont break word on the organisation number */}
                    <span style={{ display: 'inline-block' }}>Org.nr: 556710-5480</span>
                </span>
                {props.bottomLinks.map((bottomLink) => (
                    <span key={bottomLink.contentId}>
                        <a className={styles.FooterContactLink} href={bottomLink.url}>
                            {bottomLink.name}
                        </a>
                    </span>
                ))}
            </p>
        </>
    );
};

export default FooterContact;
